import Appointment from "./appointment";

class SubResult {
    appointmentsDate : Date = new Date();
    appointmentsCounter : number = 0;
    appointments : Appointment[] = []
}

export default SubResult;